/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
  'sidebar.smartstock': 'Smart  Stock',
  'sidebar.productos': 'Productos',
  'productos.agregarProductos': 'Create Productos',
  'productos.modificarProductos': 'Edit Productos',
  'productos.eliminarProductos': 'Delete Productos',
  'productos.productoId': 'Producto   Id ',
  'productos.empresaId': ' Empresa   Id ',
  'productos.estado': ' Estado',
  'productos.productos': 'Productos',
  'productos.verProductos': 'View Productos',
  'productos.descripcionProducto': 'Description',
};
